import TextGroup from './TextGroup';
import { TextGroupProps, TextGroupValueProps } from './types';

export type { TextGroupProps, TextGroupValueProps };
export default TextGroup;
